import PropTypes from 'prop-types';
export const iconPropTypes = {
  /**
   * Name of Icon
   */
  name: PropTypes.string,
  /**
   * Path of SVG
   */
  path: PropTypes.string,
  /**
   * viewBox of SVG
   */
  viewBox: PropTypes.string,
  /**
   * Icon size: width and height
   */
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  /**
   * OnClick - function
   */
  onClick: PropTypes.func,
  /**
   * Additional classname
   */
  classname: PropTypes.string
};